// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"GlobalLoader_loaderWrapper__1CwX6","statusText":"GlobalLoader_statusText__jSI2J"};